import { render, staticRenderFns } from "./flight-pad-details-bags.vue?vue&type=template&id=56d14629&scoped=true"
import script from "./flight-pad-details-bags.vue?vue&type=script&lang=js"
export * from "./flight-pad-details-bags.vue?vue&type=script&lang=js"
import style0 from "./flight-pad-details-bags.vue?vue&type=style&index=0&id=56d14629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d14629",
  null
  
)

export default component.exports